import { styled } from '@openeducation/oe-it-themes';
import type { StyleProp, ViewStyle } from 'react-native';

export interface InfoBarProps {
  backgroundColor?: string;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

export const InfoBar = ({ backgroundColor, children, style }: InfoBarProps) => (
  <Bar style={style} backgroundColor={backgroundColor}>
    {children}
  </Bar>
);

const Bar = styled.View<{ backgroundColor?: string }>`
  border-radius: 8px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.color.lightPrimary};
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding: 8px;
`;
